import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CanDeactivateHelper } from 'src/app/_helpers/can-deactivate-helper';
import { ModalService } from 'src/app/core/services/modal.service';
import { EntiteSearchor } from 'src/app/core/models/entite-searchor';
import { SearchParam } from 'src/app/core/models/search-param';
import { Dico } from 'src/app/core/models/dico';
import { MembreService } from 'src/app/membres/services/membre.service';
import { ActiviteService } from 'src/app/activites/services/activite.service';
import { IdCodeLabel } from 'src/app/core/models/IdCodeLabel';
import { AssociationActiviteMembresComponent } from '../association-activite-membres/association-activite-membres.component';
import { AssociationMembreActivitesComponent } from '../association-membre-activites/association-membre-activites.component';

@Component({
  selector: 'app-activite-membre-main',
  templateUrl: './activite-membre-main.component.html',
  styleUrls: ['./activite-membre-main.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ActiviteMembreMainComponent implements OnInit {
  form: FormGroup;
  membreId?: number;
  activiteId?: number;
  dirty = false;
  membreSearchor: EntiteSearchor<IdCodeLabel>;
  activiteSearchor: EntiteSearchor<IdCodeLabel>;
  @ViewChild(AssociationActiviteMembresComponent) aamc: AssociationActiviteMembresComponent;
  @ViewChild(AssociationMembreActivitesComponent) amac: AssociationMembreActivitesComponent;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private modalService: ModalService,
    private membreService: MembreService,
    private activiteService: ActiviteService,
  ) {
    this.form = this.fb.group({
      affichageMembreActivites: [false, Validators.required],
    });
  }

  ngOnInit() {
    this.membreSearchor = new EntiteSearchor((searchParam: SearchParam<Dico<any>>) => this.membreService.quickSearch(searchParam), {
      masque: false,
    });
    this.activiteSearchor = new EntiteSearchor((searchParam: SearchParam<Dico<any>>) => this.activiteService.quickSearch(searchParam), {
      masque: false,
    });
    this.route.queryParamMap
      .pipe(
        switchMap((queryParamMap) => {
          if (queryParamMap.has('membreId')) {
            this.membreId = +queryParamMap.get('membreId');
            this.form.get('affichageMembreActivites').setValue(true);
          }
          if (queryParamMap.has('activiteId')) {
            this.activiteId = +queryParamMap.get('activiteId');
            this.form.setValue({ affichageMembreActivites: false });
          }
          return of(null);
        }),
      )
      .subscribe();
  }

  canDeactivate(): Observable<boolean> | boolean {
    return CanDeactivateHelper.canDeactivate(this.aamc?.form.dirty || this.amac?.form.dirty, this.modalService);
  }
}
